import { render, staticRenderFns } from "./scoreRankingDialog.vue?vue&type=template&id=615f9a68&"
import script from "./scoreRankingDialog.vue?vue&type=script&lang=js&"
export * from "./scoreRankingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports